import React from 'react';
import { Alert as AlertStrap } from 'reactstrap';

const Alert = (props) => {
  //! State

  //! Function

  //! Render
  return <AlertStrap {...props} />;
};

export default Alert;
